(function () {
  const btn = document.getElementById('scroll-to-atc');
  if (!btn) {
    console.warn('[floating-cta] Button not in DOM');
    return;
  }
  console.log('[floating-cta] initialized');

  const THRESHOLD = 1700; // pixels scrolled before button shows

  function update() {
    const show = window.scrollY > THRESHOLD;
    btn.classList.toggle('is-visible', show);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  btn.addEventListener('click', () => {
    // Find the sticky header height so we don't scroll under it
    const header = document.querySelector(
      '.site-header, .header, header.shopify-section, sticky-header, #shopify-section-header, header'
    );
    let offset = 0;
    if (header) {
      const style = getComputedStyle(header);
      const rect = header.getBoundingClientRect();
      if (style.position === 'fixed' || style.position === 'sticky' || rect.top <= 0) {
        offset = rect.height;
      }
    }

    // Scroll to top of product content
    const target =
      document.querySelector('.product, .product-section, .product__info-wrapper, main, #MainContent') ||
      document.body;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });
})();